import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-custom-payment-modal',
  standalone: false,
  templateUrl: './custom-payment-modal.html',
  styleUrl: './custom-payment-modal.css'
})
export class CustomPaymentModal {
  @Input() eventName: string = '';
  @Input() paymentMethodName: string = '';
  @Input() paymentInstructions: string = '';
  @Input() totalAmount: number = 0;
  @Input() currency: string = 'NOK';

  constructor(private modal: NgbActiveModal) {}

  close() {
    this.modal.close('confirmed');
  }
}
